import {
  AfterViewInit,
  Component,
  forwardRef,
  Inject,
  Input
} from '@angular/core';

import { NgbActiveModal }   from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

import { MessagesService }         from '../messages/messages.service';
import { Table }                   from '../table/types/table';
import { TableSort }               from '../table/types/table-sort';
import { TemplatedWordingService } from './templated-wording.service';
import { TemplateModel }           from './typings/template';

@Component({
  selector   : 'wor-templated-wording',
  template: require('./templated-wording.component.html')
})
export class TemplatedWordingComponent implements AfterViewInit {
  private order = 0;

  public areAllSelected = false;
  public filterValue    = '';
  public selectedItems : Array<TemplateModel> = [];

  public tableSettings : Table = {
    broadcast: 'filterTemplates',
    columns  : [
      {
        classes: 'text-left',
        field  : 'description',
        header : {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.DESCRIPTION')
        }
      }
    ],
    empty: {
      text: this.translateService.instant('COMPANY_SPACE.LISTS.GRID.NO_TEMPLATES')
    },
    pagination: {
      enabled: false
    },
    rows: {
      highlight: {
        enabled: true
      },
      select: {
        enabled: true,
        multi  : true
      }
    },
    sorting: {
      direction: 'asc',
      enabled  : true,
      field    : 'description'
    },
    static: true
  };

  @Input() templates: Array<TemplateModel>;
  @Input() type     = 'invoice';

  constructor (
    public activeModal             : NgbActiveModal,
    private messagesService        : MessagesService,
    @Inject(forwardRef(() => TemplatedWordingService)) private templatedWordingService: TemplatedWordingService,
    private translateService       : TranslateService
  ) {}

  ngAfterViewInit (): void {
    const interval = setInterval(() => {
      if (typeof window['filterTemplates'] === 'function') {

        clearInterval(interval);

        this.filterTemplates();

      }
    }, 100);
  }

  confirm () : void {


    this.activeModal.close(this.selectedItems.sort((current, next) => current.order - next.order));


  }

  filterTemplates ( filterValue = this.filterValue ) : void {


    (window as any)[this.tableSettings.broadcast](filterValue);


  }

  getTemplates = ( params : TableSort ) => {
    return this.templatedWordingService.getTemplates(this.type, params, this.filterValue)
    .then(templates => {
      this.templates = templates;

      return templates;
    })
    .catch(err => {
      this.messagesService.error(err);
    });
  }

  handleRowClick ( template : TemplateModel ) : void {
    if ( template.selected ) {

      template.order = this.order;

      this.order++;

    }

    this.selectedItems = this.templates.filter(template => template.selected);

    this.areAllSelected = this.selectedItems.length === this.templates.length;
  }

  selectAll () : void {
    this.templates.map(template => {
      template.selected = true;
    });

    this.areAllSelected = true;
    this.selectedItems  = this.templates;
  }

  unselectAll () : void {
    this.templates.map(template => {
      template.selected = false;
    });

    this.areAllSelected = false;
    this.selectedItems  = [];
  }
}
